import React from "react";
import axios from "axios";

export const submitDetailsApi = async (id, token, details, formid) => {
    try {
      const options = {
        method: "PUT",
        url: `https://visapro-api.tcore.online/api/v1/applications/${id}/form/${formid}`,
        headers: {
          'Authorization': `Basic ${token}` 
        },
        data: details,
      };
      const response = await axios.request(options)
      const uploadDetails = {
        data: response.data.data,
      };
      return uploadDetails;
    } catch (error) {
      const uploadDetails = {
        error: error,
      };
      return uploadDetails;
  }
};
